import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { memberEndpoint } from '@/services/members/member-endpoint';

interface RemoveMemberProps {
  inviteId?: string;
  email: string;
  organizationId?: string;
}

export const removeMember = async ({
  inviteId,
  email,
  organizationId,
}: RemoveMemberProps) => {
  const orgId = organizationId || useOrgStore.getState().currentOrg?.orgid;

  const result = await apiRequest({
    url: memberEndpoint(orgId, { inviteId, email }),
    target: 'platform',
    method: 'DELETE',
  });

  if (result?.detail) {
    return { detail: result.detail || 'Failed to remove member' };
  }

  return result;
};
